import React, { useEffect, useState } from 'react';
import './styles.css';
import ORBNavBar from '../../../components/common/ORBNavBar';
import ORBApi from '../../../services/ORBApi';
import Backdrop from '@mui/material/Backdrop';
import Loading from '../../../components/common/Loading';
import { Modal } from '@mui/material';
import ActionBar, { defaultFilters } from './components/ActionBar';
import ClientsTable from './components/ClientsTable';
import ClientsForm from './components/ClientsForm';
import config from '../../../config';

const Clients = () => {
  const [data, setData] = useState();
  const [filters, setFilters] = useState(defaultFilters);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('id');
  const [formVisible, setFormVisible] = useState(false);
  const [clientOnPlay, setClientOnPlay] = useState(null);
  const [loading, setLoading] = useState(0);

  const onFilterChangeHandler = (filters) => {
    setFilters(filters);
  };

  const onPageChangeHandler = (page) => {
    if (page !== data.current_page) loadData(page);
  };

  const showClientForm = (client) => {
    if (client) setClientOnPlay(JSON.parse(JSON.stringify(client)));
    else setClientOnPlay(null);
    setFormVisible(true);
  };

  const onSaveClient = () => {
    onClose();
    loadData(1);
  };

  const onClose = () => {
    setFormVisible(false);
    setClientOnPlay(null);
  };

  const loadData = React.useCallback((page) => {
    setLoading(1);
    ORBApi.loadClients(page, filters, config.default_page_size, orderBy, order)
      .then((data) => {
        setData(data);
      })
      .finally(() => {
        setLoading(0);
      });
  }, [filters, orderBy, order]);

  const onSortChangeHandler = (newOrderBy, newOrder) => {
    setOrderBy(newOrderBy);
    setOrder(newOrder);
    // Recarrega a primeira página quando a ordenação muda
    loadData(1);
  };

  useEffect(() => {
    loadData(1);
  }, [loadData]);

  return (
    <>
      <div>
        <ORBNavBar page_title="Cadastro > Clientes" />
        <ActionBar
          formVisible={formVisible}
          setFormVisible={setFormVisible}
          onFilterChange={onFilterChangeHandler}
          total_items={data?.total_items}
          onSaveClient={onSaveClient}
        />

        {!data ? (
          loading ? (
            <Loading text="Buscando Clientes..." />
          ) : (
            <ClientsTable clients={[]} />
          )
        ) : loading ? (
          <Loading text="Buscando Clientes..." />
        ) : (
          <>
            <ClientsTable
              clients={data.clients}
              total_items={data.total_items}
              page={data.page}
              pages={data.pages}
              current_page={data.current_page}
              onPageChange={onPageChangeHandler}
              onSortChange={onSortChangeHandler}
              order={order}
              orderBy={orderBy}
              showClientForm={showClientForm}
            />
          </>
        )}
        <Modal
          size="lg"
          open={formVisible}
          onClose={onClose}
          slotsbackdropprops={Backdrop}
          slotsbackdropprops={{ timeout: 500 }}
        >
          <div className="modal-container">
            <ClientsForm
              edit_clients={clientOnPlay}
              onSaveClient={onSaveClient}
            />
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Clients;
